import {
    transformChurnOverPeriodData,
    transformMrrGraphData,
    transformOnboardingWonData,
    transformStageDistributionData,
    transformStatsData,
    transformUpsellOverPeriodData
} from "./misc/constants";
import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useDashboard = () => {
    const { platformId } = useParams();

    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const [data, setData] = useState({
        stats           : [],
        companiesByStage: { series: [] },
        onBoardingWon   : { categories: [], series: [] },
        mrrGraph        : { categories: [], series: [] },
        upsellOverPeriod: { categories: [], series: [] },
        churnOverPeriod : { categories: [], series: [] }
    });

    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();

    const getDashboardData = async () => {
        const { data } = await axiosInstance.get(
            `/report/${platformId}/global-dashboard`,
            {
                params: {
                    start: getSearchParams("start"),
                    end  : getSearchParams("end"),
                    ...queryParams
                }
            }
        );

        const apiData = data || {};
        const transformedData = {
            stats           : transformStatsData(apiData),
            companiesByStage: transformStageDistributionData(
                apiData.stageDistribution || {}
            ),
            onBoardingWon: transformOnboardingWonData(
                apiData.graphs?.OnboardingWonGraph || []
            ),
            mrrGraph        : transformMrrGraphData(apiData.graphs?.mrrGraph || []),
            upsellOverPeriod: transformUpsellOverPeriodData(
                apiData.graphs?.ExpansionGraph || []
            ),
            churnOverPeriod: transformChurnOverPeriodData(
                apiData.graphs?.churnGraph || []
            )
        };

        setData(transformedData);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getDashboardData();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams, platformId]);

    return {
        loading,
        data,
        setQueryParams,
        getDashboardData
    };
};

export default useDashboard;
